import './js/pets-list.js';
import './js/FAQ.js';
import { render } from './js/render-stories';
render();
import './js/modal-function.js';
import './js/about-us.js';
import './js/cat-decor.js';
import './js/header.js';
